const setupAlerts = () => {
	const closableAlerts = document.querySelectorAll('.alert--closable');
	if (!closableAlerts.length) return;

	closableAlerts.forEach((alert) => {

		const closeButton = alert.querySelector('.alert__trigger');
		closeButton.addEventListener('click', (e) => {
			e.preventDefault();

			alert.addEventListener('transitionend', (e) => {
				alert.remove();
			});

			alert.classList.add('alert--closing');
		});
	});
}

export { setupAlerts };
